import ProductSampleModalToggle from './product-sample-modal-toggle';

export default ProductSampleModalToggle;
